"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoOptionsMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NoOptionsMessage = function NoOptionsMessage(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.NoOptionsMessage, props, /*#__PURE__*/_react["default"].createElement("span", null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"));
};

exports.NoOptionsMessage = NoOptionsMessage;